import { render, staticRenderFns } from "./linkAccess.vue?vue&type=template&id=20e25a72&scoped=true"
import script from "./linkAccess.vue?vue&type=script&lang=js"
export * from "./linkAccess.vue?vue&type=script&lang=js"
import style0 from "./linkAccess.vue?vue&type=style&index=0&id=20e25a72&prod&scoped=true&lang=scss"
import style1 from "./linkAccess.vue?vue&type=style&index=1&id=20e25a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e25a72",
  null
  
)

export default component.exports